import { YPaymentAmount } from '../y/amount';
import { $analytics } from '../y/analytics';
import { $api } from '../y/api';
import { $http } from '../y/http';
import { YObjectId, YTimeString } from '../y/types';

export interface MEInviteContact {
    email: string;
    name?: string;
    first_name?: string;
}

export interface MEInviteModel {
    id: YObjectId;

    contact: MEInviteContact;

    resent: boolean;
    subscribed: boolean;
    discount: YPaymentAmount;

    created_at: YTimeString;
}

export function meInvitesGet() {
    return $api.GET<MEInviteModel[]>('/api/v1/invites');
}

export function meInvitesSend(contacts: MEInviteContact[], flow: 'gmail' | 'outlook' | 'field') {
    return $http.POST('/api/v1/invite', { contacts: contacts }).then(() => {
        $analytics.track('Invited friend', { count: contacts.length, flow: flow });
    });
}

export function meInviteResend(id: YObjectId) {
    return $http.POST('/api/v1/invite/' + id + '/resend');
}

// export function getGoogleContacts(token: string)
// {
//     return $http.POST<any>('/api/v1/google/contacts', { token: token });
// }

export function getOutlookContacts(token: string) {
    return $http.POST<any>('/api/v1/microsoft/contacts', { token: token });
}
